import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Generator from "@/pages/Generator";
import IdeaDetail from "@/pages/IdeaDetail";
import Validate from "@/pages/Validate";
import MyIdeas from "@/pages/MyIdeas";
import Pro from "@/pages/Pro";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import DailyArchive from "@/pages/DailyArchive";
import SharedIdea from "@/pages/SharedIdea";
import Leaderboard from "@/pages/Leaderboard";

function App() {
  return (
    <div className="app-shell grain">
      <BrowserRouter>
        <Navbar />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/genera" element={<Generator />} />
            <Route path="/idea/:id" element={<IdeaDetail />} />
            <Route path="/verifica" element={<Validate />} />
            <Route path="/le-mie-idee" element={<MyIdeas />} />
            <Route path="/pro" element={<Pro />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/paypal" element={<PaymentSuccess />} />
            <Route path="/idee-del-giorno" element={<DailyArchive />} />
            <Route path="/condivisa/:shareId" element={<SharedIdea />} />
            <Route path="/classifica" element={<Leaderboard />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
